<template>
  <div class="mycard" style="padding:20px;margin-bottom:0px;height:100%;">
    <el-row v-if="cardData" v-loading="loading" :gutter="20" style="height:100%;">
      <el-col :span="4" style="font-size: 14px;display: flex;height:100%;flex-direction: column;justify-content: flex-end;color:#303133">
        <div>
          <div class="user-name-title">{{cardData.username}}</div>
          <div>{{cardData.userDept.p_dept_name}}</div>
        </div>
      </el-col>
      <el-col v-if="false" :span="12" style="font-size: 14px;height:100%;display: flex;">
        <div>
          <div v-for="item in cardData.list1" style="display: flex;width: 200px;justify-content: space-between;">
            <div>{{item.title}}<span>({{ item.count }})</span></div>
            <div style="margin-left:50px;">{{item.amount}}</div>
          </div>
        </div>
        <div>
          <div v-for="item in cardData.list2" style="display: flex;width: 200px;justify-content: space-between;margin-left:50px;">
            <div>{{item.title}}</div>
            <div style="margin-left:50px;">{{item.count}}</div>
          </div>
        </div>

      </el-col>
      <el-col v-if="false" :span="8" style="font-size: 14px;height:200px;">
        <div style="position: relative;height:200px;width: 200px;" ref="radarChart"></div>

      </el-col>
    </el-row>
    <el-empty description="暂无数据" v-else></el-empty>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getClueTrend, getClueCensus, getClueChartCensus} from "@/api/api";

export default {
  name: "PreviewCard",
  props:['refreshCount'],
  data(){
    return {
      loading:false,
      listen:false,
      loadingMap:{},
      cardData: {
        username:this.$cookies.get("username"),
        userDept:this.$store.state.userDept,
        list1:[
          {
            title:'在手订单',
            count:8,
            amount:1000
          },
          {
            title:'变现存量',
            count:15,
            amount:1200
          },
          {
            title:'已验收未开票',
            count:23,
            amount:321
          },
          {
            title:'已开票未回款',
            count:3,
            amount:5555
          }
        ],
        list2:[
          {
            title:'活跃商机',
            count:22
          },
          {
            title:'拓客',
            count:7
          }
        ]
      }
    }
  },
  async mounted() {
    // await this.refresh(true)
    this.updateChart()
  },
  watch: {
    refreshCount() {
      this.refresh()
    },
  },

  methods:{
    updateChart(){
      let dom = this.$refs.radarChart
      let myChart = echarts.init(dom);
      console.log('myChart',dom,myChart,dom.style.width,dom.style.height)

// 绘制图表
      myChart.setOption({

        radar: {
          // shape: 'circle',
          indicator: [
            { name: '订单', max: 10 },
            { name: '口碑', max: 10 },
            { name: '风险', max: 10 },
            { name: '客情', max: 10 },
            { name: '结算', max: 10 }
          ],

          // radius: "50%",//缩放
          // center: ['50%', '50%'],//位置
          name: {
            textStyle: {
              padding: [-10, -12]  // 控制文字padding
            }
          }
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            data: [
              {
                value: [6, 7, 5, 8, 9],
                name: '个人占比'
              }
            ]
          }
        ]
      });

      this.chartHandle = myChart
      myChart.resize()
      if(!this.listen){
        this.listen = true
        window.addEventListener("resize",()=>{
          console.log('resize')
          myChart.resize()
        })
      }

    },
    async getData(){

      let postData = {
      }
      let res = await getClueCensus(postData)
      let resData = res.respData
      Object.assign(this.cardData,resData)
      this.loading = false
      // console.log('getClueCensus',resData,this.cardData)
    },

    async refresh(loading=true){
      this.loading = loading
      await this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.mycard{
  background-image:url("../../assets/img/bg.jpg");
  background-size: cover;
}
.user-name-title{
  font-size:30px;
  font-weight: 800;
}
</style>
